import React from 'react';
import { StyledDiscountError } from './styles';

export type DiscountErrorProps = {
  errors: string[];
};

const DiscountError = ({ errors }: DiscountErrorProps) => (
  <StyledDiscountError>
    {errors.map((error) => (
      <div key={error}>{error}</div>
    ))}
  </StyledDiscountError>
);

export default React.memo(DiscountError);
